import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';

export default (ChildComponent) => {
    const RequireOnboarding = (props) => {
        const { pathname } = props.location;
        const auth = useSelector(({ auth }) => auth);
        const explorePagePath = '/explore';
        const isExplorePage = pathname === explorePagePath;
        const [shouldRedirectToOnboarding, setShouldRedirectToOnboarding] = useState(false);

        useEffect(() => {
            const shouldRedirect = !auth?.user?.onboardingCompleted && !isExplorePage;
            if (shouldRedirect) {
                setShouldRedirectToOnboarding(true);
            }
        }, [auth?.user]);

        return shouldRedirectToOnboarding
            ? <Redirect to="/onboarding" />
            : <ChildComponent {...props} />;
    };

    return withRouter(RequireOnboarding);
};
